import { render } from "./index-workers.vue?vue&type=template&id=53d4332a&ts=true"
import script from "./index-workers.vue?vue&type=script&lang=ts"
export * from "./index-workers.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__